import Layout from "@/components/Layout";
import { PageSEO } from "@/components/PageSEO";

const TermsOfUse = () => (
  <Layout>
    <PageSEO
      title="Terms of Use | Hope & Wellness Healing Center"
      description="Read the terms of use for the Hope & Wellness Healing Center website."
      canonical="https://www.hwhctherapy.com/terms"
    />
    <section className="container max-w-3xl py-16">
      <h1 className="mb-2 font-display text-3xl font-bold">Terms of Use</h1>
      <p className="mb-10 text-sm text-muted-foreground">Last updated: March 13, 2026</p>

      <div className="prose prose-neutral max-w-none space-y-6 text-foreground/80 [&_p]:leading-relaxed">
        <p>
          This site is operated by <strong>Hope & Wellness Healing Center LLC</strong>.
        </p>
        <p>
          Use of this site is for informational and workspace inquiry purposes only. Submitting an inquiry does not guarantee workspace availability or create a contractual relationship.
        </p>
        <p>
          <strong>Do not submit client, patient, or protected health information through any form on this site.</strong> All clinical services and patient records are managed through SimplePractice, a HIPAA-certified platform.
        </p>
        <p>
          HWHC reserves the right to contact inquiring parties regarding their submission.
        </p>
        <p>
          By using this site you agree to these terms. If you do not agree, please do not use the site.
        </p>
        <p className="text-sm text-muted-foreground">
          Questions? Contact us at{" "}
          <a href="mailto:info@hwhctherapy.com" className="text-accent underline underline-offset-2 hover:text-accent/80">info@hwhctherapy.com</a>.
        </p>
      </div>
    </section>
  </Layout>
);

export default TermsOfUse;
